import { ButtonProps, DropdownList } from '@infotech-soe/erp-ui-kit';
import { TDatabaseId } from '@infotech-soe/metaschema';
import { isEmpty } from 'lodash';
import React, { useRef, useState } from 'react';
import { createUseStyles } from 'react-jss';

import { NotificationsViewModel } from '../../../store/slices/notifications';

import NotificationsButton from './NotificationsButton';
import handleNotificationClicked from './utils/handleNotificationClicked';
import prepareNotificationsList from './utils/prepareNotificationsList';

interface Props extends Pick<ButtonProps, 'className'> {
  unread: number;
  notifications: NotificationsViewModel;
  onNotificationClick: (id: TDatabaseId) => void;
}

const useStyles = createUseStyles({
  dropdownlist: { width: 250 },
});

const Notifications = ({
  className,
  unread,
  notifications,
  onNotificationClick,
}: Props): React.JSX.Element => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const classes = useStyles();

  return (
    <div ref={ref}>
      <NotificationsButton
        className={className}
        disabled={isEmpty(notifications)}
        unread={unread}
        onClick={() => setOpen(!open)}
      />
      <DropdownList
        className={classes.dropdownlist}
        offset={-5}
        open={open}
        options={prepareNotificationsList(notifications)}
        referenceElement={ref.current}
        onClick={value =>
          handleNotificationClicked(value, notifications, onNotificationClick)
        }
        onOpenChange={setOpen}
      />
    </div>
  );
};

export default Notifications;
